import { useSyncExternalStore } from 'react';
import type { ReadableAtom } from 'nanostores';

export const useStore = <Value>(store: ReadableAtom<Value>): Value =>
  useSyncExternalStore(store.subscribe, store.get, store.get);
